import { render, staticRenderFns } from "./navBack.vue?vue&type=template&id=ac15c0ea&scoped=true&"
import script from "./navBack.vue?vue&type=script&lang=js&"
export * from "./navBack.vue?vue&type=script&lang=js&"
import style0 from "./navBack.vue?vue&type=style&index=0&id=ac15c0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac15c0ea",
  null
  
)

export default component.exports